import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { RoomsModel } from '@bookly/shared';

/**
 * A single room rendered as a card, for viewports too narrow for the table.
 *
 * Same treatment as bad-booking-card, plus the full-width photo on top that the
 * user panel's room cards use. Presentational only — it takes the room through
 * an input and leaves click handling to whoever places it.
 */
@Component({
  selector: 'bad-room-card',
  templateUrl: './room-card.component.html',
  styleUrl: './room-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'button',
    tabindex: '0',
  },
  imports: [NgOptimizedImage],
})
export class RoomCardComponent {
  public readonly room = input.required<RoomsModel>();
}
